<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务中心设置</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <el-form ref="form"
               :model="form"
               :rules="baiWangCfgForm"
               size="medium"
               label-width="180px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="税控盘口令"
                          prop="tax_panel_pwd">
              <el-input v-model="form.tax_panel_pwd"
                        placeholder="请输入税控盘口令"></el-input>
            </el-form-item>
            <el-form-item label="数字证书密码"
                          prop="digital_cert_pwd">
              <el-input v-model="form.digital_cert_pwd"
                        placeholder="请输入数字证书密码"></el-input>
            </el-form-item>
            <el-form-item label="百旺注册码"
                          prop="bw_register_code">
              <el-input v-model="form.bw_register_code"
                        placeholder="请输入百旺注册码"></el-input>
            </el-form-item>
            <el-form-item label="销货地址单位及电话"
                          prop="address_and_phone">
              <el-input v-model="form.address_and_phone"
                        placeholder="请输入 销货地址单位及电话">
              </el-input>
            </el-form-item>
            <el-form-item label="销货单位银行帐号"
                          prop="bank_acct">
              <el-input v-model="form.bank_acct"
                        placeholder="请输入 销货单位银行帐号">
              </el-input>
            </el-form-item>
            <el-form-item label="百旺编码版本号"
                          prop="code_version_number">
              <el-input v-model="form.code_version_number"
                        placeholder="请输入 百旺编码版本号">
              </el-input>
            </el-form-item>
            <el-form-item label="开票收款人"
                          prop="ticket_payee">
              <el-input v-model="form.ticket_payee"
                        placeholder="请输入 收款人">
              </el-input>
            </el-form-item>
            <el-form-item label="开票复核人"
                          prop="ticket_reviewer">
              <el-input v-model="form.ticket_reviewer"
                        placeholder="请输入 复核人">
              </el-input>
            </el-form-item>

            <el-button type="primary"
                       style="margin: 0 0 0 50px;"
                       native-type="submit">保存
            </el-button>
          </div>
        </div>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { baiWangCfgForm } from '../finance-config.rules.js'

export default {
  mixins: [],
  components: {},
  data () {
    return {
      baiWangCfgForm,
      form: {
        'tax_panel_pwd': '',
        'digital_cert_pwd': '',
        'bw_register_code': '',
        'address_and_phone': '中国（上海）自由贸易试验区临港新片区海基六路218弄12号2楼 021-50596822',
        'bank_acct': '工商银行上海市金陵东路支行 1001268909016809212',
        'code_version_number': '40.0',
        'ticket_payee': '',
        'ticket_reviewer': '',
      },
    }
  },
  computed: {
    ...Vuex.mapState({}),
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  created () {
    this.getCfg()
  },
  mounted () {},
  methods: {
    ...Vuex.mapActions([]),
    onLoad () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    onReload () {
      this.onLoad()
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.saveCfg()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    saveCfg () {
      request.common('saveBaiWangCfg', _.cloneDeep(this.form)).then((res) => {
        this.$confirm('设置保存成功', '提示', {type: 'success'})
      })
    },
    getCfg () {
      request.common('getBaiWangCfg').then(({data}) => {
        for (const key in this.form) {
          if (Object.prototype.hasOwnProperty.call(data, key)) {
            this.form[key] = data[key]
          }
        }
      })
    },
  },
}
</script>
<style lang="scss">
</style>
<style lang="scss"
       scoped>
</style>
<style lang="scss"
       module>
</style>



// WEBPACK FOOTER //
// src/views/finance-config/pages/BaiWangCfgForm.vue